import Axios from 'axios';
import { mergeProducts } from '../../common/helpers/productModelHelpers';

function createNewColorProduct(
  currentProductData,
  colorVariationGroupProductData
) {
  const product = mergeProducts(
    currentProductData,
    colorVariationGroupProductData
  );

  // urls must be retrieved as well so we can update the link on the tile image
  const newUrl =
    colorVariationGroupProductData.selectedProductUrl.split('?')[0];

  return {
    product,
    urls: {
      product: newUrl,
    },
  };
}

function loadColorVariation(
  { state, getters },
  { color, type, index, expand = false }
) {
  Axios.get(color.url, {
    params: {
      format: 'json',
    },
  }).then((response) => {
    let currentProductEntry;
    // dynamically match the corresponding entry passed via type
    // index comes from the grid/search props passed down to tile
    if (type === 'productList') {
      currentProductEntry = getters.products[index];
    } else {
      currentProductEntry = state.results?.products[index];
    }

    if (currentProductEntry) {
      const newColorProductData = response.data.product;

      const newColorProduct = createNewColorProduct(
        currentProductEntry.product,
        newColorProductData
      );
      // We need to keep color swatches open state
      newColorProduct.product.preExpanded = expand;
      // Overwrite full product data with new one
      currentProductEntry.product = newColorProduct.product;
      // Modify only product url
      currentProductEntry.urls.product = newColorProduct.urls.product;
    }
  });
}

export { createNewColorProduct };

export default loadColorVariation;
